export default __webpack_public_path__ + "static/media/bg_top.99302a0c.svg";